window.MT_I18N = {
  es: {
    "hero.eyebrow": "Cuidado y calor natural",
    "hero.headline": "Calor para tu mascota, sin enchufes",
    "hero.subheadline": "Una manta reversible que refleja el calor corporal de tu perro o gato y crea una zona cálida y acogedora en minutos. Sin cables, sin electricidad, lavable a máquina.",
    "hero.precio_antes": "34,99 €",
    "hero.precio_actual": "24,99 €",
    "hero.precio_nota": "3 tamaños disponibles",
    "hero.boton": "Comprar ahora",

    "beneficios.eyebrow": "Por qué elegirla",
    "beneficios.headline": "Pensada para el bienestar de tu mascota",
    "beneficios.b1.titulo": "Sin electricidad",
    "beneficios.b1.texto": "Refleja el calor corporal de tu mascota: no necesita cables ni enchufes.",
    "beneficios.b2.titulo": "4 capas técnicas",
    "beneficios.b2.texto": "Superficie sherpa suave, aislamiento térmico, algodón autocalentable y base antideslizante.",
    "beneficios.b3.titulo": "Lavable a máquina",
    "beneficios.b3.texto": "Fácil de mantener limpia, lista de nuevo en minutos.",
    "beneficios.b4.titulo": "Base antideslizante",
    "beneficios.b4.texto": "Se queda en su sitio sobre sofás, camas o transportines.",

    "como.eyebrow": "Así de fácil",
    "como.headline": "Calor en tres pasos, sin electricidad",
    "como.p1.titulo": "Extiéndela",
    "como.p1.texto": "Coloca la manta en la cama, el sofá o el transportín de tu mascota.",
    "como.p2.titulo": "Deja que se acomode",
    "como.p2.texto": "En cuanto tu perro o gato se tumba, el material refleja su propio calor corporal.",
    "como.p3.titulo": "Disfruta el calor",
    "como.p3.texto": "En pocos minutos se crea una zona cálida y acogedora, sin cables ni enchufes.",

    "tamanos.eyebrow": "Elige el tamaño",
    "tamanos.headline": "Un tamaño para cada mascota",
    "tamanos.subheadline": "Disponible en tres tamaños para adaptarse a tu perro o gato.",
    "tamanos.t1.desc": "Perfecta para gatos y mascotas pequeñas.",
    "tamanos.t2.desc": "El tamaño más versátil, ideal para la mayoría de mascotas.",
    "tamanos.t2.badge": "Más elegido",
    "tamanos.t3.desc": "Ideal para un perro grande o 2 perros medianos.",

    "resenas.eyebrow": "Lo que dicen",
    "resenas.headline": "Mascotas (y dueños) felices",
    "resenas.r1.texto": "“Mi gato se queda dormido nada más tumbarse. Se nota que da calorcito de verdad, sin tener que enchufar nada.”",
    "resenas.r2.texto": "“La compré para mi perro senior y ha notado la diferencia en los días fríos. Se lava fenomenal.”",
    "resenas.r3.texto": "“Muy buena calidad y la base antideslizante funciona de verdad, no se mueve del sofá.”",

    "faq.eyebrow": "Dudas",
    "faq.headline": "Preguntas frecuentes",
    "faq.f1.p": "¿La manta necesita electricidad o pilas para calentar?",
    "faq.f1.r": "No. La manta no lleva ningún componente eléctrico ni requiere pilas, cables ni enchufes. Su interior combina 4 capas técnicas —incluido un núcleo termorreflectante— que capturan y devuelven el calor corporal que tu mascota genera de forma natural al tumbarse sobre ella. En pocos minutos de contacto se crea una zona cálida y estable, sin ningún gasto energético ni riesgo de sobrecalentamiento.",
    "faq.f2.p": "¿Cómo se lava y qué cuidados necesita?",
    "faq.f2.r": "Es apta para lavadora en ciclo suave (máx. 30°C) junto con la colada habitual. No uses lejía ni un exceso de suavizante, ya que pueden reducir la suavidad del sherpa. Puedes secarla al aire o en secadora a baja temperatura; evita el calor alto para conservar la base antideslizante. Con este cuidado, la manta mantiene su grosor, color y capacidad de retención de calor lavado tras lavado.",
    "faq.f3.p": "¿Qué tamaño debo elegir para mi mascota?",
    "faq.f3.r": "La S (50×40 cm) es perfecta para gatos y mascotas pequeñas; la M (70×50 cm) es la más versátil y se adapta a la mayoría de perros medianos y gatos grandes; y la L (115×70 cm) es ideal para perros grandes o para que dos mascotas la compartan cómodamente. Si tu mascota suele estirarse mucho al dormir o tienes dudas entre dos tallas, te recomendamos elegir la más grande para que tenga espacio de sobra.",
    "faq.f4.p": "¿Es segura para cachorros, gatitos o mascotas mayores?",
    "faq.f4.r": "Sí. Los materiales están libres de sustancias tóxicas y en ningún momento superan la temperatura corporal natural del animal, por lo que no existe riesgo de quemaduras ni sobrecalentamiento, ni siquiera para cachorros, gatitos o mascotas mayores con movilidad reducida. La base antideslizante evita además que la manta se desplace, lo que la hace especialmente segura para mascotas convalecientes o de edad avanzada.",
    "faq.f5.p": "¿Cuánto tarda en llegar mi pedido?",
    "faq.f5.r": "Los pedidos se preparan y se envían en un plazo de 24 a 48 horas laborables desde la confirmación de la compra, y llegan en 2 a 5 días laborables. El envío es GRATIS y solo realizamos envíos a España peninsular e Islas Baleares. En cuanto tu paquete sale de nuestro almacén recibirás un correo con el número de seguimiento para que puedas consultar el estado del envío en todo momento.",
    "faq.f6.p": "¿Puedo devolver la manta si no cumple mis expectativas?",
    "faq.f6.r": "Sí. Dispones de 14 días naturales desde la recepción del pedido para solicitar la devolución, siempre que el producto esté en su estado original. Escríbenos indicando tu número de pedido y el motivo. La devolución tiene un coste de 4,99 € en concepto de gastos de envío y gestión, que se descuenta del reembolso (gratis si el producto llega defectuoso o hay un error nuestro).",

    "cta.headline": "Dale a tu mascota el invierno más cómodo",
    "cta.subheadline": "Manta térmica autocalentable, sin electricidad, lavable y en 3 tamaños.",
    "cta.boton": "Comprar ahora",

    "prod.eyebrow": "Bienestar animal",
    "prod.titulo": "Manta Térmica Autocalentable para Mascotas — Calor Sin Electricidad",
    "prod.desc": "Mantén a tu mascota calentita este invierno sin gastar en electricidad. Esta manta refleja el calor corporal de tu perro o gato, creando una zona cálida y acogedora en minutos — ideal para camas, sofás o transportines.",
    "prod.stock": "En stock, envío en 24-48h (Solo Península y Islas Baleares)",
    "prod.agotado": "Agotado temporalmente",
    "prod.boton": "Comprar ahora",
    "prod.boton_agotado": "Agotado",
    "prod.confianza1": "Envío gratis",
    "prod.confianza2": "Devoluciones fáciles",
    "prod.confianza3": "Pago 100% seguro",
    "prod.caract_titulo": "Detalles del producto",
    "prod.incluye_titulo": "Qué incluye",
    "prod.c1.t": "Sherpa suave",
    "prod.c1.d": "Superficie afelpada, agradable al tacto de tu mascota.",
    "prod.c2.t": "Reversible",
    "prod.c2.d": "Dos caras de uso: sherpa cálida o base técnica antideslizante.",
    "prod.c3.t": "3 tamaños",
    "prod.c3.d": "S (50×40 cm), M (70×50 cm) y L (115×70 cm) para cualquier mascota.",
    "prod.c4.t": "Fácil cuidado",
    "prod.c4.d": "Lavable a máquina, seca rápido y mantiene su suavidad.",
    "prod.incluye_titulo": "Qué incluye",
    "prod.incluye_1": "1 manta térmica autocalentable",
    "prod.incluye_2": "Funda reversible lavable",

    "footer.tagline": "Comodidad y bienestar para tu mascota, en cada rincón de tu hogar.",
    "footer.tienda": "Tienda",
    "footer.nav1": "Todos los productos",
    "footer.nav2": "Envíos y devoluciones",
    "footer.nav3": "Términos de servicio",
    "footer.nav4": "Política de privacidad",
    "footer.sobre_t": "Sobre nosotros",
    "footer.sobre_d": "Creamos productos pensados para el bienestar de tu mascota en casa.",
    "footer.contacto_t": "Contacto",
    "footer.contacto_nota": "Este correo es solo para incidencias con tu pedido (errores o retrasos de más de 7 días). No es para publicidad.",
    "footer.copyright": "Todos los derechos reservados.",

    "anuncio": "Bienvenido a nuestra tienda",
    "menu.inicio": "Inicio",
    "menu.catalogo": "Catálogo",
    "menu.producto": "Producto",
    "menu.contacto": "Contacto"
  },
  en: {
    "hero.eyebrow": "Cozy care, naturally warm",
    "hero.headline": "Warmth for your pet, no outlets needed",
    "hero.subheadline": "A reversible blanket that reflects your dog or cat's own body heat, creating a warm, cozy spot in minutes. No cords, no electricity, machine washable.",
    "hero.precio_antes": "€34.99",
    "hero.precio_actual": "€24.99",
    "hero.precio_nota": "3 sizes available",
    "hero.boton": "Shop now",

    "beneficios.eyebrow": "Why choose it",
    "beneficios.headline": "Made for your pet's wellbeing",
    "beneficios.b1.titulo": "No electricity needed",
    "beneficios.b1.texto": "Reflects your pet's own body heat — no cords or outlets required.",
    "beneficios.b2.titulo": "4 technical layers",
    "beneficios.b2.texto": "Soft sherpa surface, thermal insulation, self-warming cotton and non-slip base.",
    "beneficios.b3.titulo": "Machine washable",
    "beneficios.b3.texto": "Easy to keep clean and ready to use again in minutes.",
    "beneficios.b4.titulo": "Non-slip base",
    "beneficios.b4.texto": "Stays in place on sofas, beds or carriers.",

    "como.eyebrow": "So simple",
    "como.headline": "Warmth in three steps, no electricity",
    "como.p1.titulo": "Lay it out",
    "como.p1.texto": "Place the blanket on your pet's bed, sofa, or carrier.",
    "como.p2.titulo": "Let them settle in",
    "como.p2.texto": "As soon as your dog or cat lies down, the material reflects their own body heat.",
    "como.p3.titulo": "Enjoy the warmth",
    "como.p3.texto": "Within minutes, a warm, cozy spot forms — no cords, no outlets.",

    "tamanos.eyebrow": "Choose your size",
    "tamanos.headline": "A size for every pet",
    "tamanos.subheadline": "Available in three sizes to fit your dog or cat.",
    "tamanos.t1.desc": "Perfect for cats and small pets.",
    "tamanos.t2.desc": "The most versatile size, ideal for most pets.",
    "tamanos.t2.badge": "Best seller",
    "tamanos.t3.desc": "Great for medium dogs or two pets together.",

    "resenas.eyebrow": "What they say",
    "resenas.headline": "Happy pets (and owners)",
    "resenas.r1.texto": "“My cat falls asleep the moment she lies down. You can really tell it gives real warmth, no need to plug anything in.”",
    "resenas.r2.texto": "“I got this for my senior dog and he's noticed the difference on cold days. Washes beautifully.”",
    "resenas.r3.texto": "“Great quality, and the non-slip base really works — it doesn't move on the sofa.”",

    "faq.eyebrow": "Questions",
    "faq.headline": "Frequently asked questions",
    "faq.f1.p": "Does the blanket need electricity or batteries to warm up?",
    "faq.f1.r": "No. The blanket has no electrical components and doesn't need batteries, cords, or outlets. Inside, it combines 4 technical layers — including a heat-reflective core — that capture and return the body heat your pet naturally generates as soon as they lie down on it. Within a few minutes of contact, a warm, stable spot forms, with zero energy cost and no risk of overheating.",
    "faq.f2.p": "How do I wash and care for it?",
    "faq.f2.r": "It's machine washable on a gentle cycle (max. 30°C/86°F) alongside a regular household load. Avoid bleach and excess fabric softener, as they can reduce the softness of the sherpa surface. Air-dry or tumble dry on low heat — avoid high heat to protect the non-slip base. With this care routine, the blanket keeps its thickness, color, and heat-retention properties wash after wash.",
    "faq.f3.p": "Which size should I choose for my pet?",
    "faq.f3.r": "Size S (50×40 cm / 20×16 in) is perfect for cats and small pets; size M (70×50 cm / 28×20 in) is the most versatile and fits most medium dogs and large cats; and size L (115×70 cm / 45×28 in) is ideal for large dogs or for two pets to share comfortably. If your pet tends to stretch out a lot while sleeping, or you're torn between two sizes, we recommend sizing up so they have plenty of room.",
    "faq.f4.p": "Is it safe for puppies, kittens, or senior pets?",
    "faq.f4.r": "Yes. The materials are free of toxic substances and never exceed the animal's own natural body temperature, so there's no risk of burns or overheating — even for puppies, kittens, or senior pets with reduced mobility. The non-slip base also keeps the blanket from shifting, making it especially safe for recovering or elderly pets.",
    "faq.f5.p": "How long does shipping take?",
    "faq.f5.r": "Orders are prepared and shipped within 24-48 business hours of purchase confirmation. As soon as your package leaves our warehouse, you'll receive an email with a tracking number so you can follow your delivery every step of the way until it reaches your door.",
    "faq.f6.p": "Can I return the blanket if it doesn't meet my expectations?",
    "faq.f6.r": "Absolutely. You have a return window after receiving your order to request an exchange or refund if the product hasn't fully convinced you, as long as it's in its original condition. Our customer service team is here to guide you through the whole process to make it as easy as possible.",

    "cta.headline": "Give your pet the coziest winter yet",
    "cta.subheadline": "Self-warming thermal blanket, no electricity, washable, in 3 sizes.",
    "cta.boton": "Shop now",

    "prod.eyebrow": "Pet wellness",
    "prod.titulo": "Self-Warming Thermal Pet Blanket — No Electricity Needed",
    "prod.desc": "Keep your pet warm this winter without spending on electricity. This blanket reflects your dog or cat's own body heat, creating a warm, cozy spot in minutes — perfect for beds, sofas, or carriers.",
    "prod.stock": "In stock, ships in 24-48h",
    "prod.agotado": "Temporarily out of stock",
    "prod.boton": "Add to cart",
    "prod.boton_agotado": "Out of stock",
    "prod.confianza1": "Fast shipping",
    "prod.confianza2": "Easy returns",
    "prod.confianza3": "100% secure payment",
    "prod.caract_titulo": "Product details",
    "prod.incluye_titulo": "What's included",
    "prod.c1.t": "Soft sherpa",
    "prod.c1.d": "Plush surface that feels great against your pet's skin.",
    "prod.c2.t": "Reversible",
    "prod.c2.d": "Two sides to use: cozy sherpa or technical non-slip base.",
    "prod.c3.t": "3 sizes",
    "prod.c3.d": "S (50×40 cm), M (70×50 cm) and L (115×70 cm) for any pet.",
    "prod.c4.t": "Easy care",
    "prod.c4.d": "Machine washable, dries fast and stays soft.",
    "prod.incluye_titulo": "What's included",
    "prod.incluye_1": "1 self-warming thermal blanket",
    "prod.incluye_2": "Washable reversible cover",

    "footer.tagline": "Comfort and wellness for your pet, in every corner of home.",
    "footer.tienda": "Shop",
    "footer.nav1": "All products",
    "footer.nav2": "Shipping & returns",
    "footer.nav3": "Terms of service",
    "footer.nav4": "Privacy policy",
    "footer.sobre_t": "About us",
    "footer.sobre_d": "We create products designed for your pet's wellbeing at home.",
    "footer.contacto_t": "Contact",
    "footer.contacto_nota": "This email is only for issues with your order (errors or delays of more than 7 days). Not for advertising.",
    "footer.copyright": "All rights reserved.",

    "anuncio": "Welcome to our store",
    "menu.inicio": "Home",
    "menu.catalogo": "Catalog",
    "menu.producto": "Product",
    "menu.contacto": "Contact"
  }
};

(function () {
  function getLang() {
    var htmlLang = document.documentElement.getAttribute("lang") || "es";
    return window.MT_I18N[htmlLang] ? htmlLang : "es";
  }
  function switchRealLanguage(lang) {
    var form = document.getElementById("HeaderLanguageForm");
    if (!form) return false;
    var input = form.querySelector('input[name="locale_code"]');
    if (!input) return false;
    input.value = lang;
    form.submit();
    return true;
  }
  function applyLang(lang) {
    var dict = window.MT_I18N[lang] || window.MT_I18N.es;
    document.documentElement.setAttribute("data-mt-lang", lang);
    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      var key = el.getAttribute("data-i18n");
      if (dict[key] !== undefined) el.textContent = dict[key];
    });
    document.querySelectorAll("[data-i18n-disponible][data-i18n-agotado]").forEach(function (el) {
      var disponibleKey = el.getAttribute("data-i18n-disponible");
      var agotadoKey = el.getAttribute("data-i18n-agotado");
      var disponibleTexto = dict[disponibleKey];
      var agotadoTexto = dict[agotadoKey];
      if (disponibleTexto === undefined || agotadoTexto === undefined) return;
      el.setAttribute("data-texto-disponible", disponibleTexto);
      el.setAttribute("data-texto-agotado", agotadoTexto);
      var estaAgotado = el.matches("[disabled]") || document.querySelector(".mt-producto__punto--agotado") != null;
      el.textContent = estaAgotado ? agotadoTexto : disponibleTexto;
    });
    document.querySelectorAll("[data-mt-lang-btn]").forEach(function (btn) {
      btn.setAttribute("data-activo", btn.getAttribute("data-mt-lang-btn") === lang ? "true" : "false");
    });
    document.querySelectorAll('.mt-faq__item[data-abierto="true"] .mt-faq__respuesta').forEach(function (r) {
      r.style.maxHeight = r.scrollHeight + "px";
    });
  }
  function init() {
    applyLang(getLang());
    document.querySelectorAll("[data-mt-lang-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var lang = btn.getAttribute("data-mt-lang-btn");
        if (lang === getLang()) return;
        try { localStorage.setItem("mt_lang", lang); } catch (e) {}
        applyLang(lang);
        switchRealLanguage(lang);
      });
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
